import { module } from 'stereomodularjs'

import Swiper from 'swiper';
import { Navigation, Pagination, A11y} from 'swiper';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, A11y]);

export default class extends module {
    constructor(m) {
        super(m)
    }

    init() {
        this.params = {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 1,
            grabCursor: true,
            spaceBetween: 20,

            // If we need pagination
            pagination: {
                el: this.el.querySelector('.swiper-pagination'),
                clickable: true,
            },

            // a11y
            a11y: {
                // prevSlideMessage: 'Previous slide',
                // nextSlideMessage: 'Next slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
            },
        }

        this.typeSlider = this.el.dataset.type

        if (this.typeSlider == 'img') {
            this.params.navigation = {
                nextEl: this.el.querySelector('.swiper-button-next'),
                prevEl: this.el.querySelector('.swiper-button-prev'),
            }
            this.params.slidesPerView = 1.075
            this.params.centeredSlides = true
            this.params.centeredSlidesBounds = true
            this.params.loop = false
            this.params.speed = 750
            this.params.spaceBetween = 0
            this.params.breakpoints = {
                768: {
                    slidesPerView: 1.1,
                },
                1024: {
                    slidesPerView: 1.15,
                },
                1280: {
                    slidesPerView: 1.2,
                },
                1440: {
                    slidesPerView: 1.2125,
                },
                1600: {
                    slidesPerView: 1.35,
                },
                1920: {
                    slidesPerView: 1.4,
                },
            }
            setTimeout(() => {
                this.el.querySelector('.swiper-controls').style.width = this.el.querySelector('.swiper-slide > *').offsetWidth + 'px'
            }, 100)
            window.addEventListener('resize', () => {
                setTimeout(() => {
                    this.el.querySelector('.swiper-controls').style.width = this.el.querySelector('.swiper-slide > *').offsetWidth + 'px'
                }, 100)
            })
        }

        if (this.typeSlider == 'person') {
            this.params.navigation = {
                nextEl: this.el.querySelector('.swiper-button-next'),
                prevEl: this.el.querySelector('.swiper-button-prev'),
            }
            this.params.slidesPerView = 1.1
            this.params.centeredSlides = true
            this.params.centeredSlidesBounds = true
            this.params.loop = true
            this.params.speed = 750
            this.params.spaceBetween = 40
            this.params.pagination = false
            this.params.breakpoints = {
                768: {
                    slidesPerView: 1.1,
                },
                1024: {
                    slidesPerView: 1.2,
                },
                1280: {
                    slidesPerView: 1.3,
                },
                1440: {
                    slidesPerView: 1.4,
                },
                1600: {
                    slidesPerView: 1.5,
                },
                1920: {
                    slidesPerView: 1.6,
                },
            }
            setTimeout(() => {
                this.el.querySelector('.swiper-controls').style.width = this.el.querySelector('.swiper-slide > *').offsetWidth + 'px'
            }, 100)
            window.addEventListener('resize', () => {
                setTimeout(() => {
                    this.el.querySelector('.swiper-controls').style.width = this.el.querySelector('.swiper-slide > *').offsetWidth + 'px'
                }, 100)
            })
        }

        this.slider = new Swiper(this.el, this.params)

    }
}